export default "__VITE_ASSET__cjPDoVT2__"